
import { InvoiceType } from 'graphql-query-contracts';

/**
 * Determines if invoicing options should be enabled for a work order.
 * @param isBillingInvoicingDisabled - Global flag for billing/invoicing.
 * @param isWorkOrderInvoiceOptionsEnabled - Optional flag for work order-specific invoicing options.
 * @returns {boolean} True if options should be enabled, false otherwise.
 */
export function getInvoicingOptionsEnabledValue(
    isBillingInvoicingDisabled: boolean,
    isWorkOrderInvoiceOptionsEnabled?: boolean
  ): boolean {

    if (isBillingInvoicingDisabled) return false;

    if (typeof isWorkOrderInvoiceOptionsEnabled === 'boolean')
      return isWorkOrderInvoiceOptionsEnabled;

    return true;
  }

/**
 * Determines the default invoice type for a work order.
 * @param isBillingInvoicingDisabled - Global flag for billing/invoicing.
 * @param isWorkOrderInvoiceOptionsEnabled - Optional flag for work order-specific invoicing options.
 * @returns {InvoiceType} The default invoice type.
 */
export function getDefaultInvoiceType(
    isBillingInvoicingDisabled: boolean,
    isWorkOrderInvoiceOptionsEnabled?: boolean
  ): InvoiceType {
    
    if (isBillingInvoicingDisabled) return InvoiceType.InvoiceTypeNoInvoice;

    if (typeof isWorkOrderInvoiceOptionsEnabled === 'boolean' && !isWorkOrderInvoiceOptionsEnabled){
      return InvoiceType.InvoiceTypeNoInvoice;
    }
   
    return InvoiceType.InvoiceTypeOneoff;
  }

  export function showChargeStatus(
    isBillingInvoicingDisabled: boolean,
    isWorkOrderInvoiceOptionsEnabled?: boolean
  ) : boolean {
    if (isBillingInvoicingDisabled) return false;
  
    if (typeof isWorkOrderInvoiceOptionsEnabled === 'boolean')
      return isWorkOrderInvoiceOptionsEnabled;
  
    return true;
  }